export default "__VITE_ASSET__7zjj2P30__"